export default __webpack_public_path__ + "static/media/trash-small.5da8f12e.svg";